import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css'
import { DBCheckBoxInputComment } from '_components'

class PatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds extends React.Component {
    render() {

            return (
                <PatientCareCenterNoteSection id='obj_obs_grossmotorpeds' name='Gross Motor Development' level={2} noChildPadding={true}>
                    <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRROLLPROTOSUP'
                         className={styles.checkbox}
                         label='Rolling - prone to supine'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRROLLSUPTOPRO'
                         className={styles.checkbox}
                         label='Rolling - supine to prone'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRSIT'
                         className={styles.checkbox}
                         label='Sitting'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRTRANSIT'
                         checkboxStyle={styles.checkbox_size}
                         label='Transition into / out of sitting'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRCRAWL'
                         className={styles.checkbox}
                         label='Crawling'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRTRANQUAD'
                         checkboxStyle={styles.checkbox_size}
                         label='Transition into / out of quadruped'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRCREEP'
                         className={styles.checkbox}
                         label='Creeping'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRPULLTOSTAND'
                         className={styles.checkbox}
                         label='Pull to stand'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRWALK'
                         className={styles.checkbox}
                         label='Walking'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRTRANSTAND'
                         checkboxStyle={styles.checkbox_size}
                         label='Transition into / out of standing'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRRUN'
                         className={styles.checkbox}
                         label='Run'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRTRANWHEEL'
                         checkboxStyle={styles.checkbox_size}
                         label='Transition into / out of chair or wheelchair'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGRWHEEL'
                         className={styles.checkbox}
                         label='Wheel chair mobility'
                         placeholder='Comments'
                       />
                    </div>
                  </div>

                  <div className={styles.form_row}>
                       <div className={styles.gap}>
                        <DBCheckBoxInputComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVEPEDS'
                         entityKeyColumn='OPNO'
                         entityKeyValue={this.props.opno}
                         field= 'OPGROTHER'
                         className={styles.checkbox}
                         label='Other'
                         placeholder='Comments'
                       />
                    </div>
                  </div>


                </PatientCareCenterNoteSection>
            );
       
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));
    
    return {
        noteId: noteId,
        opno: opno
    };
}

const connectedPatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds = connect(mapStateToProps)(PatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds);
export { connectedPatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds as PatientCareCenterNoteObjectiveObsGrossMotorDevelopmentPeds };

